import React, { useContext, useEffect, useState } from "react";
import styles from "./Step.module.css";
import StepsHeader from "../../../Components/StepsHeader/StepsHeader";
import Vacancy from "../../../assets/componentAssets/Vacancy.png";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import NavButton from "./NavButton";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import PopUpInfo from "../../../Components/PopUpInfo/PopUpInfo";
import { PatchApi, getApi } from "../../../Utility/network";
import CustomInput from "../../../Components/CustomInput/CustomInput";
import { distributionHeating, typesOfRenewableEnergy } from "../utility/utils";
import CustomCheckBox from "../../../Components/CustomCheckBox/CustomCheckBox";
import {
  arrayId,
  convertCommaToDot,
  ordinalSuffix,
} from "../../../Utility/utils";
import generatorIcon from "../../../assets/componentAssets/generatorIcon.svg";
import { selectedLanguage } from "../../../Utility/helper";
import { errorMessage } from "../../../Utility/constants";
import info from "../../../assets/componentAssets/info.svg";
function Step4() {
  const { state, setState, HandleErrorPop } = useContext(AppContext);
  const { language, needLanguage } = state;
  const [renewable, setRenewable] = useState([]);
  const [errors, setErrors] = useState([]);
  const [errors1, setErrors1] = useState([]);
  const [disableNext, setDisableNext] = useState(true);
  const [initialLoad, setInitialLoad] = useState(false);
  const [loadingHeatingData, setLoadingHeatingData] = useState(false);

  const [errorObj, setErrorObj] = useState({
    renewable: false,
    cooling: false, // Added for future cooling systems
  });
  const [submitData, setSubmitData] = useState({
    are_renewable_energy_used: false,
    type_of_renewable_energy_id: [],
    unobstructed_collector_area: 1,
    do_u_have_solar_collector: false,
    number_of_conditioning_system: "1", // Added field
  });
  const [response, setResponse] = useState(false);
  const [drop, setDrop] = useState({
    heating: [],
    water: [],
    energy: [],
    distributed: [],
    renew: [],
  });
  const [data, setData] = useState({
    heating_systems: [
      {
        energy_source_id: null,
        heating_system_id: null,
        installation_year: null,
        index: 1,
        distribution_heating: null,
        share_of_heating: 100,
        data: null,
      },
    ],
    hot_water: [],
  });
  const [show, setShow] = useState(1);
  const [show1, setShow1] = useState(0);
  const [infoText, setInfoText] = useState([]);
  const [pop, setPop] = useState(false);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setSubmitData((prev) => ({
      ...prev,
      [name]:
        name === "are_renewable_energy_used"
          ? value == "true"
            ? true
            : false
          : value,
    }));
  };

  // Simplified initialization logic - API data is the single source of truth
  const initializeData = () => {
    if (initialLoad) return; // Prevent multiple initialization cycles

    console.log("Initializing data:", {
      hasHeating: state?.heating && Object.keys(state.heating).length > 0,
      hasNeedData: state.needData,
      heatingSystemsLength: state.needData?.heating_systems?.length,
      currentDataLength: data.heating_systems.length,
    });

    // Priority 1: Check needData for existing backend data (API is the source of truth)
    const { heating_systems, hot_water_systems } = state.needData || {};
    if (heating_systems?.length > 0 || hot_water_systems?.length > 0) {
      console.log("Loading from needData", {
        heating_systems,
        hot_water_systems,
      });
      loadFromNeedData();
      setInitialLoad(true);
      return;
    }

    // Priority 2: Initialize with empty defaults if no API data exists
    console.log("Initializing defaults");
    initializeDefaults();
    setInitialLoad(true);
  };

  const loadFromNeedData = () => {
    const {
      heating_systems,
      are_renewable_energy_used,
      do_u_have_solar_collector,
      hot_water_systems,
      unobstructed_collector_area,
      type_of_renewable_energy,
    } = state.needData;

    console.log("loadFromNeedData - Raw heating_systems:", heating_systems);

    // Map heating systems with proper ID extraction
    const heatingData =
      heating_systems?.map((item, index) => {
        const {
          energy_source,
          energy_source_id,
          heating_system,
          heating_system_id,
          ...rest
        } = item;

        let energy_source_ids = energy_source?.hasOwnProperty("id")
          ? energy_source.id
          : energy_source_id || null;

        let heating_system_ids = heating_system?.hasOwnProperty("id")
          ? heating_system.id
          : heating_system_id || null;

        console.log(`Heating system ${index}:`, {
          energy_source_ids,
          heating_system_ids,
          installation_year: rest.installation_year,
          distribution_heating: rest.distribution_heating,
        });

        return {
          ...rest,
          energy_source_id: energy_source_ids,
          heating_system_id: heating_system_ids,
          index: index + 1,
          data: null, // Will be populated by getDataHeat
        };
      }) || [];

    console.log("loadFromNeedData - Mapped heatingData:", heatingData);

    // Map hot water systems with proper ID extraction
    const hotWaterData =
      hot_water_systems?.map((item, index) => {
        const {
          energy_source,
          water_heating,
          energy_source_id,
          water_heating_id,
          ...rest
        } = item;

        let energy_source_ids = energy_source?.hasOwnProperty("id")
          ? energy_source.id
          : energy_source_id || null;

        let water_heating_ids = water_heating?.hasOwnProperty("id")
          ? water_heating.id
          : water_heating_id || null;

        return {
          ...rest,
          energy_source_id: energy_source_ids,
          water_heating_id: water_heating_ids,
          index: index + 1,
        };
      }) || [];

    // Set initial data first
    setData({ heating_systems: heatingData, hot_water: hotWaterData });
    setShow(heatingData.length || 1);
    setShow1(hotWaterData.length || 0);

    setSubmitData({
      are_renewable_energy_used: are_renewable_energy_used || false,
      do_u_have_solar_collector: do_u_have_solar_collector || false,
      unobstructed_collector_area: unobstructed_collector_area || 1,
      type_of_renewable_energy_id: arrayId(type_of_renewable_energy) || [],
      number_of_conditioning_system:
        state.needData.number_of_air_conditioning_systems?.toString() || "1",
    });

    // Load heating systems for existing years - load immediately for first system, stagger others
    heatingData.forEach((item, index) => {
      const yearString = item?.installation_year?.toString?.();
      if (yearString && yearString.length === 4) {
        // Load immediately for first system to avoid empty dropdown
        if (index === 0) {
          loadHeatingSystemsForYear(item.installation_year, index);
        } else {
          setTimeout(() => {
            loadHeatingSystemsForYear(item.installation_year, index);
          }, 100 * index); // Stagger API calls for subsequent systems
        }
      }
    });
  };

  const initializeDefaults = () => {
    // Initialize with default heating system
    const defaultHeatingSystem = [
      {
        energy_source_id: null,
        heating_system_id: null,
        installation_year: null,
        index: 1,
        distribution_heating: null,
        share_of_heating: 100,
        data: null,
      },
    ];

    setData({
      heating_systems: defaultHeatingSystem,
      hot_water: [],
    });
    setShow(1);
    setShow1(0);

    setSubmitData({
      are_renewable_energy_used: false,
      type_of_renewable_energy_id: [],
      unobstructed_collector_area: 1,
      do_u_have_solar_collector: false,
      number_of_conditioning_system: "1",
    });
  };

  useEffect(() => {
    initializeData();
  }, [state.needData, state.heating]);

  // Ensure initialization happens on component mount
  useEffect(() => {
    if (!initialLoad) {
      initializeData();
    }
  }, []);

  // Removed old getDataHeat function - replaced with loadHeatingSystemsForYear for individual heating systems

  // Removed automatic useEffect for getDataHeat - now handled individually per heating system

  // Build current step payload function for consistent API payload structure
  const buildCurrentStepPayload = () => {
    const { heating_systems, hot_water } = data;

    // Normalize hot water systems with proper decimal conversion and data cleaning
    const normalizedHotWater = hot_water.map((item, idx) => {
      // Only include the exact fields expected by the API
      return {
        water_heating_id: item.water_heating_id || null,
        energy_source_id: item.energy_source_id || null,
        installation_year: item.installation_year
          ? parseInt(item.installation_year)
          : null,
        index: idx + 1,
        share_of_heating: convertCommaToDot(
          item.share_of_heating?.toString() || "100"
        ),
      };
    });

    // Normalize heating systems with proper decimal conversion and data cleaning
    const normalizedHeatingSystem = heating_systems.map((item, idx) => {
      // Only include the exact fields expected by the API
      return {
        energy_source_id: item.energy_source_id || null,
        heating_system_id: item.heating_system_id || null,
        installation_year: item.installation_year
          ? parseInt(item.installation_year)
          : null,
        index: idx + 1,
        distribution_heating: item.distribution_heating || null,
        share_of_heating: convertCommaToDot(
          item.share_of_heating?.toString() || "100"
        ),
      };
    });

    // Build complete payload with proper data normalization
    const payload = {
      heating_systems: normalizedHeatingSystem,
      hot_water_systems: normalizedHotWater,
      are_renewable_energy_used: Boolean(submitData.are_renewable_energy_used),
      do_u_have_solar_collector: Boolean(submitData.do_u_have_solar_collector),
      unobstructed_collector_area:
        parseFloat(submitData.unobstructed_collector_area) || 1,
      number_of_air_conditioning_systems:
        parseInt(submitData.number_of_conditioning_system) || 1,
      language: language === "de" ? 2 : 1,
    };

    // Only include renewable energy types if renewable energy is enabled
    if (
      submitData.are_renewable_energy_used &&
      submitData.type_of_renewable_energy_id?.length > 0
    ) {
      payload.type_of_renewable_energy_id =
        submitData.type_of_renewable_energy_id;
    }

    return payload;
  };

  // Persist current step function for data persistence without navigation
  const persistCurrentStep = async () => {
    try {
      // Build API payload with proper data normalization
      const payload = buildCurrentStepPayload();

      // Validate payload structure before API call
      if (!payload.heating_systems || !Array.isArray(payload.heating_systems)) {
        throw new Error("Invalid heating systems data structure");
      }

      if (
        !payload.hot_water_systems ||
        !Array.isArray(payload.hot_water_systems)
      ) {
        throw new Error("Invalid hot water systems data structure");
      }

      // Update global context state before API call
      setState((prev) => ({
        ...prev,
        needData: {
          ...prev.needData,
          heating_systems: data.heating_systems,
          hot_water_systems: data.hot_water,
          are_renewable_energy_used: submitData.are_renewable_energy_used,
          do_u_have_solar_collector: submitData.do_u_have_solar_collector,
          unobstructed_collector_area: submitData.unobstructed_collector_area,
          ...(submitData.are_renewable_energy_used && {
            type_of_renewable_energy_id: submitData.type_of_renewable_energy_id,
          }),
        },
        heating: {
          ...submitData,
          heating_systems: data.heating_systems,
          hot_water: data.hot_water,
        },
      }));

      // Call API to persist data with enhanced error handling
      const response = await PatchApi(`/energy_need/${state.needId}/`, payload);

      // Enhanced response validation
      if (response && (response.status === 200 || response.status === 201)) {
        // Safely extract response data
        const responseData = response.data?.data || {};
        const { type_of_renewable_energy } = responseData;

        // Update needData with API response if available
        if (type_of_renewable_energy) {
          setState((prev) => ({
            ...prev,
            needData: {
              ...prev.needData,
              type_of_renewable_energy,
            },
          }));
        }

        return { success: true, data: response.data };
      } else {
        // Handle non-success status codes
        const errorMsg =
          response?.data?.message ||
          response?.statusText ||
          "API call failed with unexpected status";
        throw new Error(errorMsg);
      }
    } catch (error) {
      // Enhanced error handling with detailed logging
      console.error("Error persisting current step:", error);

      // Categorize different types of errors
      if (error.name === "TypeError" && error.message.includes("fetch")) {
        console.error("Network error during API call:", error);
        return {
          success: false,
          error: new Error(
            "Network connection failed. Please check your internet connection."
          ),
        };
      } else if (error.response) {
        // API returned an error response
        console.error("API error response:", error.response);
        const apiError =
          error.response.data?.message ||
          error.response.statusText ||
          "API request failed";
        return { success: false, error: new Error(apiError) };
      } else if (error.request) {
        // Request was made but no response received
        console.error("No response received:", error.request);
        return {
          success: false,
          error: new Error("No response from server. Please try again."),
        };
      } else {
        // Something else happened
        console.error("Unexpected error:", error);
        return { success: false, error };
      }
    }
  };
  // Enhanced validateFields function with improved error handling
  const validateFields = () => {
    const { heating_systems, hot_water } = data;

    // Deep clone to avoid mutation issues
    let heating = JSON.parse(JSON.stringify(heating_systems));
    let hotWater = JSON.parse(JSON.stringify(hot_water));

    let error1 = [];
    let error2 = [];
    let hasValidationErrors = false;

    // Enhanced heating systems validation
    heating.forEach((info, idx) => {
      const consumptionErrors = {};

      // Define required fields for heating systems
      const requiredFields = [
        "energy_source_id",
        "heating_system_id",
        "installation_year",
        "distribution_heating",
      ];

      // Add share_of_heating to required fields only if multiple systems
      if (show > 1) {
        requiredFields.push("share_of_heating");
      }

      for (const key in info) {
        // Skip non-validation fields
        if (["index", "data"].includes(key)) {
          continue;
        }

        // Skip share_of_heating validation if only one heating system
        if (key === "share_of_heating" && show <= 1) {
          consumptionErrors[key] = ""; // No validation needed for single system
          continue;
        }

        // Check if field is required and validate accordingly
        if (requiredFields.includes(key)) {
          if (info[key] == null || info[key] == undefined || info[key] === "") {
            consumptionErrors[key] = needLanguage.required_field_error;
            hasValidationErrors = true;
          } else if (key === "share_of_heating") {
            // Enhanced language-specific validation for share_of_heating
            const validationResult = validateShareOfHeating(
              info[key],
              language
            );
            if (!validationResult.isValid) {
              consumptionErrors[key] = validationResult.errorMessage;
              hasValidationErrors = true;
            } else {
              consumptionErrors[key] = ""; // Validation passed
            }
          } else {
            consumptionErrors[key] = ""; // Field has value and is valid
          }
        } else {
          consumptionErrors[key] = ""; // Non-required field
        }
      }

      // Always add error object for each heating system (even if empty)
      error1[idx] = consumptionErrors;
    });

    // Enhanced hot water systems validation
    if (hotWater.length > 0) {
      hotWater.forEach((info, idx) => {
        const consumptionErrors = {};

        // Define required fields for hot water systems
        const requiredFields = [
          "water_heating_id",
          "energy_source_id",
          "installation_year",
        ];

        // Add share_of_heating to required fields only if multiple systems
        if (show1 > 1) {
          requiredFields.push("share_of_heating");
        }

        for (const key in info) {
          // Skip non-validation fields
          if (key === "index") {
            continue;
          }

          // Skip share_of_heating validation if only one hot water system
          if (key === "share_of_heating" && show1 <= 1) {
            consumptionErrors[key] = ""; // No validation needed for single system
            continue;
          }

          // Check if field is required and validate accordingly
          if (requiredFields.includes(key)) {
            if (
              info[key] == null ||
              info[key] == undefined ||
              info[key] === ""
            ) {
              consumptionErrors[key] = needLanguage.required_field_error;
              hasValidationErrors = true;
            } else if (key === "share_of_heating") {
              // Enhanced language-specific validation for share_of_heating
              const validationResult = validateShareOfHeating(
                info[key],
                language
              );
              if (!validationResult.isValid) {
                consumptionErrors[key] = validationResult.errorMessage;
                hasValidationErrors = true;
              } else {
                consumptionErrors[key] = ""; // Validation passed
              }
            } else {
              consumptionErrors[key] = ""; // Field has value and is valid
            }
          } else {
            consumptionErrors[key] = ""; // Non-required field
          }
        }

        // Always add error object for each hot water system
        error2[idx] = consumptionErrors;
      });
    }

    // Enhanced renewable energy validation
    const { are_renewable_energy_used, type_of_renewable_energy_id } =
      submitData;
    let renewableError = false;

    if (
      are_renewable_energy_used === true &&
      type_of_renewable_energy_id.length === 0
    ) {
      renewableError = true;
      hasValidationErrors = true;
    }

    // Update error state management to include cooling field
    setErrorObj({
      renewable: renewableError,
      cooling: false, // Future use for cooling systems
    });

    setErrors(error1);
    setErrors1(error2);

    // Return true if there are validation errors (prevents submission)
    return hasValidationErrors;
  };

  // Enhanced language-specific validation helper for share_of_heating
  const validateShareOfHeating = (value, language) => {
    if (!value && value !== 0) {
      return {
        isValid: false,
        errorMessage: needLanguage.required_field_error,
      };
    }

    const stringValue = value.toString();

    if (language === "de") {
      // German validation: accepts comma as decimal separator
      const germanRegex = /^[0-9]+(,[0-9]+)?$/;

      if (!germanRegex.test(stringValue)) {
        return {
          isValid: false,
          errorMessage: needLanguage.required_field_error,
        };
      }

      // Convert comma to dot for numerical validation
      const normalizedValue = convertCommaToDot(stringValue);
      const numericValue = parseFloat(normalizedValue);

      if (isNaN(numericValue) || numericValue < 0 || numericValue > 100) {
        return {
          isValid: false,
          errorMessage: needLanguage.required_field_error,
        };
      }
    } else {
      // English validation: accepts dot as decimal separator
      const englishRegex = /^\d+(\.\d+)?$/;

      if (!englishRegex.test(stringValue)) {
        return {
          isValid: false,
          errorMessage: needLanguage.required_field_error,
        };
      }

      const numericValue = parseFloat(stringValue);

      if (isNaN(numericValue) || numericValue < 0 || numericValue > 100) {
        return {
          isValid: false,
          errorMessage: needLanguage.required_field_error,
        };
      }
    }

    return {
      isValid: true,
      errorMessage: "",
    };
  };

  const handleSubmit = async (num, type) => {
    // Proper loading state management with setDisableNext
    setDisableNext(true);

    try {
      if (type === "next") {
        // Enhanced validation that prevents submission when errors exist
        const hasValidationErrors = validateFields();

        if (hasValidationErrors) {
          console.log("Validation failed - preventing form submission");
          setDisableNext(false);
          return;
        }

        // Use new persistence and payload functions with proper data normalization
        const persistResult = await persistCurrentStep();

        if (persistResult.success) {
          // Update navigation state only after successful API call
          setState((prev) => ({
            ...prev,
            needPage: 5,
            needFilledPage: prev.needFilledPage >= 5 ? prev.needFilledPage : 5,
          }));
        } else {
          // Enhanced error handling with specific error messages
          const errorMsg =
            persistResult.error?.message ||
            persistResult.error ||
            "Failed to save data";
          console.error("API persistence failed:", errorMsg);
          throw new Error(errorMsg);
        }
      } else if (type === "prev") {
        // Persist current step data before navigation (no validation required for backward navigation)
        try {
          await persistCurrentStep();
        } catch (error) {
          // Log error but don't prevent navigation for previous step
          console.warn(
            "Failed to persist data during backward navigation:",
            error
          );
        }

        setState((prev) => ({
          ...prev,
          needPage: prev.needPage - 1,
        }));
      } else if (type === "save") {
        // For save operation, validate first to ensure data integrity
        const hasValidationErrors = validateFields();

        if (hasValidationErrors) {
          console.log("Validation failed - cannot save incomplete data");
          setDisableNext(false);
          return;
        }

        // Persist current step data first with enhanced error handling
        const persistResult = await persistCurrentStep();

        if (persistResult.success) {
          // Generate resume link with proper error handling
          try {
            const linkResponse = await getApi(
              `/energy_need/${state.needId}/generate_link/`
            );
            if (linkResponse.status === 200 || linkResponse.status === 201) {
              setResponse(true);
            } else {
              throw new Error("Failed to generate resume link");
            }
          } catch (linkError) {
            console.error("Error generating resume link:", linkError);
            // Still show success for data save, but log link generation error
            setResponse(true);
          }
        } else {
          const errorMsg =
            persistResult.error?.message ||
            persistResult.error ||
            "Failed to save data before generating link";
          throw new Error(errorMsg);
        }
      }
    } catch (error) {
      // Enhanced error handling with try-catch blocks
      console.error("Error in handleSubmit:", error);

      // Show user-friendly error message
      if (
        error.message?.includes("Network Error") ||
        error.message?.includes("fetch")
      ) {
        console.error("Network error detected:", error);
      } else if (error.message?.includes("validation")) {
        console.error("Validation error:", error);
      } else {
        console.error("General error:", error);
      }

      // Trigger global error handler
      HandleErrorPop(true);
    } finally {
      // Always re-enable the next button in finally block
      setDisableNext(false);
    }
  };
  useEffect(() => {
    getData();
    window.scroll(0, 0);
  }, []);

  // Debug: Log when data changes
  useEffect(() => {
    console.log("Data state updated:", data);
  }, [data]);

  // Debug: Log when drop changes
  useEffect(() => {
    console.log("Drop state updated:", drop);
  }, [drop]);

  const getData = async () => {
    try {
      // Enhanced API calls with proper error handling
      const [heating, water, renewableEnergy, energy, renew] =
        await Promise.all([
          getApi(`/energy_need/heating_systems/`),
          getApi(`/energy_need/hot_water_types/`),
          getApi(`/energy_need/renewable_energy_usage/`),
          getApi(`/energy_consumption/energy_source`),
          getApi(`/energy_consumption/renewable_energy_types`),
        ]);

      // Validate API responses before setting state
      if (renew?.data?.data) {
        setRenewable(renew.data.data);
      }

      setDrop({
        heating: heating?.data?.data || [],
        water: water?.data?.data || [],
        energy: energy?.data?.data || [],
        distributed: distributionHeating || [],
      });

      // Only enable next button after successful data loading
      setDisableNext(false);
    } catch (error) {
      console.error("Error loading dropdown data:", error);

      // Set empty arrays as fallback to prevent UI crashes
      setDrop({
        heating: [],
        water: [],
        energy: [],
        distributed: distributionHeating || [],
      });

      // Still enable the button but log the error
      setDisableNext(false);

      // Optionally show user notification about data loading issues
      console.warn("Some dropdown data failed to load. Using fallback values.");
    }
  };

  const handleClick = (_count) => {
    const dataObject = heat; // Object structure for each form
    const newData = [...data.heating_systems]; // Copy the current data array

    // If the array length is less than the clicked number, add more objects
    if (newData.length < _count) {
      const objectsToAdd = _count - newData.length;

      for (let i = 0; i < objectsToAdd; i++) {
        newData.push({
          ...dataObject,
          index: i + 1,
        });
      }

      // If the array length is more than the clicked number, remove extra objects
    } else if (newData.length > _count) {
      newData.splice(_count); // Trim the array to the clicked length
    }

    // Always update the state to ensure proper rendering
    setData((prev) => ({
      ...prev,
      heating_systems: newData,
      number_of_heating_systems: _count,
    }));
    setState((prev) => ({
      ...prev,
      needData: { ...prev.needData, heatingSystemsCount: newData },
    }));
  };
  // This useEffect is now handled by the priority-based initialization logic above
  const handleCheckboxChange = (name, checkedIds) => {
    if (name === "type_of_renewable_energy_id") {
      setSubmitData((prev) => ({
        ...prev,
        type_of_renewable_energy_id: checkedIds,
      }));
    }
  };

  const handleClick1 = (_count) => {
    const dataObject = hot_water; // Object structure for each form
    const newData = [...data.hot_water]; // Copy the current data array

    // If the array length is less than the clicked number, add more objects
    if (newData.length < _count) {
      const objectsToAdd = _count - newData.length;

      for (let i = 0; i < objectsToAdd; i++) {
        newData.push({
          ...dataObject,
          index: newData.length + i + 1,
        });
      }

      // If the array length is more than the clicked number, remove extra objects
    } else if (newData.length > _count) {
      newData.splice(_count); // Trim the array to the clicked length
    }

    // Update the state only if there is a change
    if (newData.length !== data.hot_water.length) {
      setData((prev) => ({
        ...prev,
        hot_water: newData,
      }));
      setState((prev) => ({
        ...prev,
        needData: { ...prev.needData, hotSystemsCount: newData },
      }));
    }
  };
  const handleChange1 = (name, value, item) => {
    setSubmitData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChangeButton = (e, index, field) => {
    const { value, name } = e.target; // Get the input value

    setData((prevData) => {
      // Make a copy of the previous state
      const newData = [...prevData[field]];
      // Update the specific field of the object at the given index
      newData[index] = { ...newData[index], [name]: value };

      // If installation year is being updated for heating systems
      if (field === "heating_systems" && name === "installation_year") {
        if (value.toString().length === 4) {
          // Clear heating system selection when year changes
          newData[index] = { ...newData[index], heating_system_id: null };
          // Trigger heating system data loading for 4-digit years
          setTimeout(() => {
            loadHeatingSystemsForYear(value, index);
          }, 100);
        } else {
          // Clear dynamic data and heating system selection if year is not 4 digits
          newData[index] = {
            ...newData[index],
            data: null,
            heating_system_id: null,
          };
        }
      }

      return { ...prevData, [field]: newData }; // Return the updated array
    });
  };

  // New function to load heating systems for a specific year and heating system index
  const loadHeatingSystemsForYear = async (year, systemIndex) => {
    setLoadingHeatingData(true);

    try {
      const response = await getApi(
        `/energy_need/heating_systems/?year=${year}`
      );

      if (response?.data?.data) {
        setData((prevData) => {
          const newHeatingData = [...prevData.heating_systems];
          newHeatingData[systemIndex] = {
            ...newHeatingData[systemIndex],
            data: response.data.data,
          };

          return {
            ...prevData,
            heating_systems: newHeatingData,
          };
        });
      }
    } catch (error) {
      console.error("Error loading heating systems for year:", year, error);
      // Clear data on error
      setData((prevData) => {
        const newHeatingData = [...prevData.heating_systems];
        newHeatingData[systemIndex] = {
          ...newHeatingData[systemIndex],
          data: [],
        };

        return {
          ...prevData,
          heating_systems: newHeatingData,
        };
      });
    } finally {
      setLoadingHeatingData(false);
    }
  };

  const handlePopUp = (data) => {
    setPop(true);
    setInfoText(data);
  };
  const popData = {
    source: [
      {
        heading: needLanguage.source,
        para1: needLanguage.source_info,
      },
    ],
    installed: [
      {
        heading: needLanguage.install_h,
        para1: needLanguage.heating_system_installed_on_paragraph,
      },
    ],
  };
  return (
    <div>
      <div className={styles.con}>
        <StepsHeader
          image={generatorIcon}
          heading={needLanguage.heat_generator_details}
          secPara={needLanguage.Please_provide_proper_information}
        />
        <div className={styles.fieldDetails}>
          <p className={styles.fieldName}>
            {needLanguage.heating_system_installed}
          </p>
          <div className={styles.num}>
            <Button
              variant={show === 1 ? "contained" : "outlined"}
              onClick={() => {
                setShow(1);
                setState((prev) => ({
                  ...prev,
                  needData: {
                    ...prev.needData,
                    heatingSystemsCount: 1,
                  },
                }));
                // setButtonError("");
                handleClick(1);
              }}
            >
              <b>1</b>
            </Button>
            <Button
              variant={show === 2 ? "contained" : "outlined"}
              onClick={() => {
                setShow(2);
                setState((prev) => ({
                  ...prev,
                  needData: {
                    ...prev.needData,
                    heatingSystemsCount: 2,
                  },
                }));
                // setButtonError("");
                handleClick(2);
              }}
            >
              <b>2</b>
            </Button>
            <Button
              variant={show === 3 ? "contained" : "outlined"}
              onClick={() => {
                setShow(3);
                setState((prev) => ({
                  ...prev,
                  needData: {
                    ...prev.needData,
                    heatingSystemsCount: 3,
                  },
                }));
                // setButtonError("");
                handleClick(3);
              }}
            >
              <b>3</b>
            </Button>
            <Button
              variant={show === 4 ? "contained" : "outlined"}
              onClick={() => {
                setShow(4);
                setState((prev) => ({
                  ...prev,
                  needData: {
                    ...prev.needData,
                    heatingSystemsCount: 4,
                  },
                }));
                // setButtonError("");
                handleClick(4);
              }}
            >
              <b>4</b>
            </Button>
          </div>
          <div>
            {data.heating_systems.map((item, index) => {
              let energySourceError = errors[index]?.energy_source_id;
              let heatingSystemError = errors[index]?.heating_system_id;
              let distributedHeatingError = errors[index]?.distribution_heating;
              let installationYearError = errors[index]?.installation_year;
              let shareOfheating = errors[index]?.share_of_heating;
              const suffixNumber = ordinalSuffix(index + 1);

              return (
                <div
                  key={`heating_system_${index}`}
                  className={styles.fieldCom}
                >
                  <div className={styles.fields}>
                    <p className={styles.fieldName}>
                      {needLanguage.energy_source}
                      <img
                        src={info}
                        style={{ cursor: "pointer" }}
                        onClick={() => handlePopUp(popData?.source)}
                      />
                    </p>
                    <FormControl fullWidth error={Boolean(energySourceError)}>
                      <Select
                        size="small"
                        fieldType={3}
                        name="energy_source_id"
                        value={item.energy_source_id ?? ""}
                        onChange={(e) =>
                          handleChangeButton(e, index, "heating_systems")
                        }
                      >
                        {drop.energy.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {selectedLanguage(option, language)}
                          </MenuItem>
                        ))}
                      </Select>
                      {energySourceError && (
                        <FormHelperText
                          id={`energySourceError-${index}`}
                          style={{ color: `${errorMessage}` }}
                        >
                          {energySourceError}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </div>
                  <div className={styles.fields}>
                    <p className={styles.fieldName}>
                      {needLanguage?.year_of}{" "}
                      {language == "de" ? index + 1 + "." : suffixNumber}{" "}
                      {needLanguage?.heating_install}
                      <img
                        src={info}
                        style={{ cursor: "pointer" }}
                        onClick={() => handlePopUp(popData?.installed)}
                      />
                    </p>
                    <TextField
                      size="small"
                      style={{ width: "100%" }}
                      value={item.installation_year}
                      name="installation_year"
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) =>
                        handleChangeButton(e, index, "heating_systems")
                      }
                      error={installationYearError}
                      helperText={installationYearError}
                    />
                  </div>{" "}
                  {/* Heating system dropdown - always visible, populated after year is entered */}
                  <div className={styles.fields}>
                    <p className={styles.fieldName}>
                      {needLanguage.heating_system}
                    </p>
                    <FormControl
                      fullWidth
                      error={Boolean(heatingSystemError)}
                    >
                      <Select
                        size="small"
                        value={item.heating_system_id ?? ""}
                        name="heating_system_id"
                        disabled={loadingHeatingData || !item.data}
                        onChange={(e) =>
                          handleChangeButton(e, index, "heating_systems")
                        }
                      >
                        {/* Use dynamic data from item.data if available, otherwise use drop.heating */}
                        {(item.data || drop.heating).map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {selectedLanguage(option, language)}
                          </MenuItem>
                        ))}
                      </Select>
                      {heatingSystemError && (
                        <FormHelperText
                          id={`heatingSystemError-${index}`}
                          style={{ color: `${errorMessage}` }}
                        >
                          {heatingSystemError}
                        </FormHelperText>
                      )}
                      {loadingHeatingData && (
                        <FormHelperText>
                          {needLanguage.loading ||
                            "Loading heating systems..."}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </div>{" "}
                  <div className={styles.fields}>
                    <p className={styles.fieldName}>
                      {needLanguage.distribution_heating}
                    </p>
                    <FormControl fullWidth>
                      <Select
                        size="small"
                        value={item.distribution_heating ?? ""}
                        name="distribution_heating"
                        onChange={(e) =>
                          handleChangeButton(e, index, "heating_systems")
                        }
                      >
                        {drop.distributed.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {selectedLanguage(option, language)}
                          </MenuItem>
                        ))}
                      </Select>
                      {distributedHeatingError && (
                        <FormHelperText
                          id={`distributedHeatingError-${index}`}
                          style={{ color: `${errorMessage}` }}
                        >
                          {distributedHeatingError}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </div>{" "}
                  {/* Conditional display: show share_of_heating only when multiple heating systems */}
                  {show > 1 && (
                    <div className={styles.fields}>
                      <p className={styles.fieldName}>
                        {needLanguage.share_heating}
                      </p>
                      <TextField
                        size="small"
                        style={{ width: "100%" }}
                        value={item.share_of_heating}
                        name="share_of_heating"
                        onWheel={(e) => e.target.blur()}
                        label=""
                        onChange={(e) =>
                          handleChangeButton(e, index, "heating_systems")
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">%</InputAdornment>
                          ),
                        }}
                        type="number"
                        error={shareOfheating}
                        helperText={shareOfheating}
                      />{" "}
                    </div>
                  )}
                  {/* <div className={styles.fields}>
                    <p className={styles.fieldName}>Water Heating</p>
                    <FormControl fullWidth>
                      <Select
                        size="small"
                        value={item.water_heating_id}
                        name="water_heating_id"
                        onChange={(e) =>
                          handleChangeButton(e, index, "heating_systems")
                        }
                      >
                        {drop.water.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>{" "} */}
                  {/* <div className={styles.fields}>
                    <p className={styles.fieldName}>
                      Source of energy for heating water
                    </p>
                    <FormControl fullWidth>
                      <Select
                        size="small"
                        value={item.water_heating_energy_source_id}
                        name="water_heating_energy_source_id"
                        onChange={(e) =>
                          handleChangeButton(e, index, "heating_systems")
                        }
                      >
                        {drop.energy.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div> */}
                  <div className={styles.hr}></div>
                </div>
              );
            })}
          </div>

          <p className={styles.fieldName}>{needLanguage?.water_system}</p>
          <div className={styles.num}>
            <Button
              variant={show1 === 0 ? "contained" : "outlined"}
              onClick={() => {
                setShow1(0);
                setState((prev) => ({
                  ...prev,
                  needData: {
                    ...prev.needData,
                    hotSystemsCount: 0,
                  },
                }));
                // setButtonError("");
                handleClick1(0);
              }}
            >
              <b>0</b>
            </Button>
            <Button
              variant={show1 === 1 ? "contained" : "outlined"}
              onClick={() => {
                setShow1(1);
                setState((prev) => ({
                  ...prev,
                  needData: {
                    ...prev.needData,
                    hotSystemsCount: 1,
                  },
                }));
                // setButtonError("");
                handleClick1(1);
              }}
            >
              <b>1</b>
            </Button>
            <Button
              variant={show1 === 2 ? "contained" : "outlined"}
              onClick={() => {
                setShow1(2);
                setState((prev) => ({
                  ...prev,
                  needData: {
                    ...prev.needData,
                    hotSystemsCount: 2,
                  },
                }));
                // setButtonError("");
                handleClick1(2);
              }}
            >
              <b>2</b>
            </Button>
            <Button
              variant={show1 === 3 ? "contained" : "outlined"}
              onClick={() => {
                setShow1(3);
                setState((prev) => ({
                  ...prev,
                  needData: {
                    ...prev.needData,
                    hotSystemsCount: 3,
                  },
                }));
                // setButtonError("");
                handleClick1(3);
              }}
            >
              <b>3</b>
            </Button>
            <Button
              variant={show1 === 4 ? "contained" : "outlined"}
              onClick={() => {
                setShow1(4);
                setState((prev) => ({
                  ...prev,
                  needData: {
                    ...prev.needData,
                    hotSystemsCount: 4,
                  },
                }));
                // setButtonError("");
                handleClick1(4);
              }}
            >
              <b>4</b>
            </Button>
          </div>
          <div>
            {data.hot_water.map((item, index) => {
              let energySourceError = errors1[index]?.energy_source_id;
              let waterHeating = errors1[index]?.water_heating_id;
              let installationYearError = errors1[index]?.installation_year;
              let shareOfheating = errors1[index]?.share_of_heating;
              const suffixNumber = ordinalSuffix(index + 1);
              return (
                <div className={styles.fieldCom} key={`hot_water_${index}`}>
                  <div className={styles.fields}>
                    <p className={styles.fieldName}>
                      {needLanguage.water_heating}
                    </p>
                    <FormControl fullWidth error={Boolean(waterHeating)}>
                      <Select
                        size="small"
                        value={item.water_heating_id ?? ""}
                        name="water_heating_id"
                        onChange={(e) =>
                          handleChangeButton(e, index, "hot_water")
                        }
                      >
                        {drop.water.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {selectedLanguage(option, language)}
                          </MenuItem>
                        ))}
                      </Select>
                      {waterHeating && (
                        <FormHelperText
                          id={`waterHeating-${index}`}
                          style={{ color: `${errorMessage}` }}
                        >
                          {waterHeating}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </div>{" "}
                  <div className={styles.fields}>
                    <p className={styles.fieldName}>
                      {needLanguage.energy_source}
                      <img
                        src={info}
                        style={{ cursor: "pointer" }}
                        onClick={() => handlePopUp(popData?.source)}
                      />
                    </p>
                    <FormControl fullWidth error={Boolean(energySourceError)}>
                      <Select
                        size="small"
                        value={item.energy_source_id ?? ""}
                        name="energy_source_id"
                        onChange={(e) =>
                          handleChangeButton(e, index, "hot_water")
                        }
                      >
                        {drop.energy.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {selectedLanguage(option, language)}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {energySourceError && (
                      <FormHelperText
                        id={`energySourceError-${index}`}
                        style={{ color: `${errorMessage}` }}
                      >
                        {energySourceError}
                      </FormHelperText>
                    )}
                  </div>
                  <div className={styles.fields}>
                    <p className={styles.fieldName}>
                      {needLanguage?.year_of}{" "}
                      {language == "de" ? index + 1 + "." : suffixNumber}{" "}
                      {needLanguage?.water_install}
                      <img
                        src={info}
                        style={{ cursor: "pointer" }}
                        onClick={() => handlePopUp(popData?.installed)}
                      />
                    </p>
                    <TextField
                      size="small"
                      style={{ width: "100%" }}
                      value={item.installation_year ?? ""}
                      name="installation_year"
                      onWheel={(e) => e.target.blur()}
                      label=""
                      onChange={(e) =>
                        handleChangeButton(e, index, "hot_water")
                      }
                      error={Boolean(installationYearError)}
                      helperText={installationYearError}
                    />{" "}
                  </div>{" "}
                  {/* Conditional display: show share_of_heating only when multiple hot water systems */}
                  {show1 > 1 && (
                    <div className={styles.fields}>
                      <p className={styles.fieldName}>
                        {needLanguage.share_heating}
                      </p>
                      <TextField
                        size="small"
                        style={{ width: "100%" }}
                        value={item.share_of_heating ?? ""}
                        name="share_of_heating"
                        label=""
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) =>
                          handleChangeButton(e, index, "hot_water")
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">%</InputAdornment>
                          ),
                        }}
                        error={Boolean(shareOfheating)}
                        helperText={shareOfheating}
                      />{" "}
                    </div>
                  )}
                  <div className={styles.hr}></div>
                </div>
              );
            })}
          </div>

          <div className={styles.fieldDetailsCon}>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {needLanguage.renewable_energy}
              </p>
              <RadioGroup
                name="are_renewable_energy_used" // Name of the radio group
                value={submitData.are_renewable_energy_used} // Bind the state value
                onChange={handleChange} // Handle value changes
              >
                <div className={styles.Radio}>
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label={needLanguage.yes}
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label={needLanguage.no}
                  />
                </div>
              </RadioGroup>
              <p style={{ color: "#d32f2f", fontSize: "12px" }}>
                {errorObj.renewable ? needLanguage.select_option : ""}
              </p>
              {submitData.are_renewable_energy_used && (
                <div>
                  <CustomCheckBox
                    data={renewable}
                    name="type_of_renewable_energy_id"
                    onCheckChange={handleCheckboxChange}
                    selectedValues={submitData.type_of_renewable_energy_id}
                  />
                </div>
              )}
            </div>
          </div>

          {/* <div className={styles.fields}>
            <CustomInput
              label="Unobstructed collector area (solar thermal energy)"
              endIcon="m&#178;"
              name="unobstructed_collector_area"
              value={submitData.unobstructed_collector_area}
              onChange={handleChange1}
            />
          </div> */}
          {/* <div
            style={{
              background: "#AFDB2840",
              marginTop: "15px",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            <p className={styles.fieldName}>
              Do the solar collectors or systems possess the European quality
              certification 'Solar Keymark'?
            </p>

            <RadioGroup
              name="do_u_have_solar_collector" // Name of the radio group
              value={submitData.do_u_have_solar_collector} // Bind the state value
              onChange={handleChange} // Handle value changes
            >
              <div className={styles.Radio}>
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="no"
                />
              </div>
            </RadioGroup>
          </div> */}
        </div>
      </div>
      <NavButton
        handleSubmit={handleSubmit}
        response={response}
        disabled={disableNext}
      />
      {pop && (
        <PopUpInfo
          handleClose={() => setPop(false)}
          open={pop}
          data={infoText}
        />
      )}
    </div>
  );
}

export default Step4;

const heat = {
  energy_source_id: null,
  heating_system_id: null,
  installation_year: null,
  index: 1,
  distribution_heating: null,
  share_of_heating: 100,
  data: null, // Added for dynamic heating system options
};

const hot_water = {
  energy_source_id: null,
  water_heating_id: null,
  installation_year: null,
  index: 1,
  share_of_heating: 100,
};
